import { deiterateAPI } from '@/js/external-js/variableModules/utils/deiterateAPI.util';

const ROLES_API = '/v1/roles';

export interface ISMSRole {
  id: string;
  dateAdded: any;
  roleName: string;
  roleDescription: string;
}

export async function fetchISMSRoles(companyID: string): Promise<ISMSRole[]> {
  try {
    const res = await deiterateAPI.GET(`${ROLES_API}/isms`, {
      mode: 'cors',
      backend: 'thalassa',
      headers: { 'X-Tenancy-Id': companyID, 'Company-ID': companyID }
    });

    return res.ismsRoles || [];
  } catch (error) {
    console.error('Error fetching ISMS roles:', error);
    return [];
  }
}

export function onISMSRolesChange(companyID: string, callback: (roles: ISMSRole[]) => void): () => void {
  let isSubscribed = true;
  let lastRoles: ISMSRole[] = [];

  const checkForUpdates = async () => {
    if (!isSubscribed) return;
    
    try {
      const roles = await fetchISMSRoles(companyID);
      if (JSON.stringify(roles) !== JSON.stringify(lastRoles)) {
        lastRoles = roles;
        callback(roles);
      }
    } catch (error) {
      console.error('Error in ISMS roles listener:', error);
    }
    
    if (isSubscribed) {
      setTimeout(checkForUpdates, 10000);
    }
  };

  checkForUpdates();

  return () => {
    isSubscribed = false;
  };
}
